import { Pipe, PipeTransform } from '@angular/core';
import { toSentenceCase } from '@app/core/functions/toSentenceCase';

@Pipe({
    name: 'sentencecase',
    standalone: false
})
export class SentenceCasePipe implements PipeTransform {
    transform(value: string | null | undefined): string | null {
        return toSentenceCase(value);
    }
}
